import { styled } from '@withjoy/joykit/theme';
import { Box } from '../Box';
import type { TextV2Props } from './Text';

export const StyledContainer = styled(Box)<TextV2Props>`
  ${props => {
    return props.truncate
      ? {
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        }
      : {};
  }}
`;
